module.exports = __webpack_public_path__ + "img/window.0d8fe42f.png";